import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TodoDescriptionEditor.html?raw';
import lang from 'dojo/_base/lang';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import MainCatalogSelectV2 from '../MainCatalogSelectV2';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { TodoDescriptionMode_Values, MainCatalogs_Classes, MainCatalogTypes as MCT } from "../../_loadingHelpers/MainCatalogTypes";
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import Edit from '../../../moreCore/UI/Edit/Edit';

class TodoDescriptionEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private todoCategorySelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;
    private todoCategory_SelectContainer: HTMLDivElement;

    private input_ModeCurrentUser : MdsLax<InstanceType<typeof SelectBox>>;
    private input_ModeEvProjectRefProjectleader: MdsLax<InstanceType<typeof SelectBox>>;

    private inputReminders: MdsLax<InstanceType<typeof HintBox>>;
    private selectedReminders: Array<MCT.TodoDescription_RemindersTable_Entry> = [];
    private remindersTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private remindersTableContainer: HTMLElement;
    private expanderReminders: MdsLax<InstanceType<typeof ExpandableSection>>;

    private inputAssociateGroups: MdsLax<InstanceType<typeof HintBox>>;
    private selectedAssociateGroups: Array<MCT.TodoDescription_AssociateGroupsTable_Entry> = [];
    private associateGroupsTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private associateGroupsTableContainer: HTMLElement;
    private expanderAssociateGroup: MdsLax<InstanceType<typeof ExpandableSection>>;

    private inputTodoTelecommunications: MdsLax<InstanceType<typeof HintBox>>;
    private selectedTodoTelecommunications: Array<MCT.TodoDescription_TodoTelecommunicationsTable_Entry> = [];
    private todoTelecommunicationsTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private todoTelecommunicationsTableContainer: HTMLElement;
    private expanderTodoTelecommunications: MdsLax<InstanceType<typeof ExpandableSection>>;

    private inputTodoPackage: MdsLax<InstanceType<typeof HintBox>>;
    private selectedTodoPackages: Array<MCT.TodoDescription_TodoPackageTable_Entry> = [];
    private todoPackageTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private todoPackageTableContainer: HTMLElement;
    private expanderTodoPackage: MdsLax<InstanceType<typeof ExpandableSection>>;

    private _updateTablesTimeoutHandler: any = null;

    private input_Description: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;

    private checkbox_AlertCheck: MdsLax<InstanceType<typeof CheckBox>>;
    private input_DaysForerun1: MdsLax<InstanceType<typeof NumberInput>>;
    private input_DaysForerun2: MdsLax<InstanceType<typeof NumberInput>>;
    private dayForerunIsReadOnly: boolean = false;
    private checkbox_Active:MdsLax<InstanceType<typeof CheckBox>>;
    private input_Note:MdsLax<InstanceType<typeof Edit>>;

    isValid(): boolean {
        let isValid = true;

        isValid = this.input_Description.isValid && isValid;

        return isValid;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        var category = this.getAttributeValue("ref_todo_category.ID");
        this.todoCategorySelect.setCatalog(MainCatalogs_Classes.TodoCategory,
            this.translate("General_Label_TodoCategory"), category);

        this.selectedReminders = lang.clone(this.getAttributeValue("reminders"));
        this.selectedAssociateGroups = lang.clone(this.getAttributeValue("associateGroups"));
        this.selectedTodoTelecommunications = lang.clone(this.getAttributeValue("todoTelecommunications"));
        this.selectedTodoPackages = lang.clone(this.getAttributeValue("todoPackages"));

        if (this._updateTablesTimeoutHandler != null) {
            clearTimeout(this._updateTablesTimeoutHandler);

            this._updateAllTables();
        }

        let is_instantly = this.getAttributeValue("is_instantly");
        this._onChangeIsInstantly(is_instantly);
        if ((this.isNew ?? false) == true){
            this.checkbox_Active?.setReadonly(true);
        }else{
            this.checkbox_Active?.setReadonly(false);
        }
    }

    private _updateAllTables() {
        for (let e in MCT.TodoDescription_SelectedEntriesListNames) {
            this.updateSelectedEntriesTable(MCT.TodoDescription_SelectedEntriesListNames[e]);
        }
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.TodoDescription;
    }
    private _createSelectOptionsFromEnum() {

        for (let option in TodoDescriptionMode_Values) {

            let value: any = TodoDescriptionMode_Values[option];

            if (!isNaN(value)) {
                this.input_ModeCurrentUser.addOption(
                    value,
                    this.translate("todo_description_mode_" + value.toString()),
                    true);

                this.input_ModeEvProjectRefProjectleader.addOption(
                    value,
                    this.translate("todo_description_mode_" + value.toString()),
                    true);
            }
        }
        this.input_ModeCurrentUser.constructOptions();
        this.input_ModeEvProjectRefProjectleader.constructOptions();
    }

    private _onChangeReminders() {

        let value = this.inputReminders.getValue() as MCT.TodoDescription_RemindersData;

        this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.reminders, value, "userID", "gDisp_1");

        this.inputReminders.setValue(null, true);
    }

    private _onChangeAssociateGroups() {

        let value = this.inputAssociateGroups.getValue() as MCT.TodoDescription_AssociateGroupsData;

        this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.associateGroups, value, "groupID", "description");

        this.inputAssociateGroups.setValue(null, true);
    }
    private _onChangeTodoTelecommunications() {

        let value = this.inputTodoTelecommunications.getValue() as MCT.TodoDescription_TodoTelecommunicationsData;

        this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.todoTelecommunications, value, "telecomID", "telecom_code");

        this.inputTodoTelecommunications.setValue(null, true);
    }
    private _onChangeTodoPackage() {

        let value = this.inputTodoPackage.getValue() as MCT.TodoDescription_TodoPackageData;

        this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.todoPackages, value, "packageID", "description");

        this.inputTodoPackage.setValue(null, true);
     }
    private _onChangeCategorySelect() {

        var value = this.todoCategorySelect.getValue();
        this.setAttributeValue("ref_todo_category", value, true);
    }

    private _onChangeIsInstantly(e) {
        if (e) {
            this.checkbox_AlertCheck.setValue(false, true);
            this.checkbox_AlertCheck.setReadonly(true);

            this.input_DaysForerun1.setValue(null, true);
            this.input_DaysForerun1.setReadonly(true);
            this.input_DaysForerun2.setValue(null, true);
            this.input_DaysForerun2.setReadonly(true);
            this.dayForerunIsReadOnly = true;
        } else {
            this.checkbox_AlertCheck.setValue(this.sourceData.is_alert_check, true);
            this.checkbox_AlertCheck.setReadonly(false);

            this.input_DaysForerun1.setValue(this.sourceData.days_forerun_1, true);
            this.input_DaysForerun1.setReadonly(false);
            this.input_DaysForerun2.setValue(this.sourceData.days_forerun_2, true);
            this.input_DaysForerun2.setReadonly(false);
            this.dayForerunIsReadOnly = false;
        }
    }

    private _setUpTodoCategorySelect() {

        this.todoCategorySelect = new MainCatalogSelectV2();

        this.todoCategorySelect.placeAt(this.todoCategory_SelectContainer);
        this.todoCategorySelect.on("change", lang.hitch(this, this._onChangeCategorySelect));

        this.todoCategorySelect.setCatalog(MainCatalogs_Classes.TodoCategory,
            this.translate("General_Label_TodoCategory"));
    }

    private addNewEntry<T>(listName: MCT.TodoDescription_SelectedEntriesListNames, value: T, idKey: string, descriptionKey: keyof T ) {

        if (value == null) return;
        let selectedEntries;
        switch (listName) {
            case MCT.TodoDescription_SelectedEntriesListNames.reminders:
                selectedEntries = this.selectedReminders;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.associateGroups:
                selectedEntries = this.selectedAssociateGroups;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.todoTelecommunications:
                selectedEntries = this.selectedTodoTelecommunications;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.todoPackages:
                selectedEntries = this.selectedTodoPackages;
                break;
            default:
                return;
        }

        let existingEntry = selectedEntries.filter(x => x[idKey] === value["ID"])[0] as MCT.TodoDescription_TableEntry;

        if (existingEntry && existingEntry.isDeleted !== true) {
            this.showToast({
                title: this.translate(`MainCatalogsEditor_${listName.toUpperCase()}_Toast_ExistInList`),
                message: `**${value[descriptionKey]}**  ${this.translate(`MainCatalogsEditor_${listName.toUpperCase() }_Toast_ExistInList_details`)}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            });
            return;
        }

        if (existingEntry && existingEntry.isDeleted === true) {
            existingEntry.isDeleted = false;
            this.setAttributeValue(listName, lang.clone(selectedEntries));
            this.updateSelectedEntriesTable(listName);
            return;
        }

        let fakeEntry: T = {
            ...value,
            [idKey]: value["ID"],
            assignmentID: null,
            isDeleted: false
        };

        selectedEntries.push(fakeEntry);
        this.setAttributeValue(listName, lang.clone(selectedEntries));
        this.updateSelectedEntriesTable(listName);
    }

    private updateSelectedEntriesTable(listName: MCT.TodoDescription_SelectedEntriesListNames) {
        let expander: MdsLax<InstanceType<typeof ExpandableSection>>;
        let table: MdsLax<InstanceType<typeof StaticTable>>;
        switch (listName) {
            case MCT.TodoDescription_SelectedEntriesListNames.reminders:
                expander = this.expanderReminders;
                table = this.remindersTable;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.associateGroups:
                expander = this.expanderAssociateGroup;
                table = this.associateGroupsTable;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.todoTelecommunications:
                expander = this.expanderTodoTelecommunications;
                table = this.todoTelecommunicationsTable;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.todoPackages:
                expander = this.expanderTodoPackage;
                table = this.todoPackageTable;
                break;
            default:
                return;
        }

        let selectedEntriesArray: Array<MCT.TodoDescription_TableEntry> = lang.clone(this.getAttributeValue(listName));
        selectedEntriesArray?.length > 0 ? expander.setMarking(ExpandableSectionMarkings.hasContent) : expander.setMarking(ExpandableSectionMarkings.default);

        table.setData(selectedEntriesArray);

        selectedEntriesArray?.forEach(s => {
            if (s.isDeleted === true) {
                this.disableNode(table.getRowGroupByKeyValue(s.assignmentID, "assignmentID").rows[0].node);
            }
        });
    }

    private removeEntry(listName: MCT.TodoDescription_SelectedEntriesListNames,
        idKey: string,
        rowGr: StaticTable.StaticTableRowGroup<MCT.TodoDescription_RemindersTable_Entry | MCT.TodoDescription_AssociateGroupsTable_Entry | MCT.TodoDescription_TodoTelecommunicationsTable_Entry | MCT.TodoDescription_TodoPackageTable_Entry>) {

        let entry = rowGr.entity;
        let selectedEntries;

        switch (listName) {
            case MCT.TodoDescription_SelectedEntriesListNames.reminders:
                selectedEntries = this.selectedReminders;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.associateGroups:
                selectedEntries = this.selectedAssociateGroups;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.todoTelecommunications:
                selectedEntries = this.selectedTodoTelecommunications;
                break;
            case MCT.TodoDescription_SelectedEntriesListNames.todoPackages:
                selectedEntries = this.selectedTodoPackages;
                break;
            default:
                return;
        }

        let deletedEntry = selectedEntries.filter(x => x[idKey] === entry[idKey] && x.assignmentID === entry.assignmentID)[0];

        if (entry.assignmentID == null) {

            selectedEntries.splice(selectedEntries.indexOf(deletedEntry), 1);
        } else {

            deletedEntry.isDeleted = true;
        }

        this.setAttributeValue(listName, lang.clone(selectedEntries));

        this.updateSelectedEntriesTable(listName);
    }

    private _setUpTables(response: { layouts: Array<any> }) {

        if (this.remindersTable != null) this.remindersTable.destroy();
        if (this.associateGroupsTable != null) this.associateGroupsTable.destroy();
        if (this.todoPackageTable != null) this.todoPackageTable.destroy();
        if (this.todoTelecommunicationsTable != null) this.todoTelecommunicationsTable.destroy();

        this.remindersTable = new StaticTable();
        this.remindersTable.placeAt(this.remindersTableContainer);

        let map = response.layouts.map((l) => { return l.name; });

        this.remindersTable.setLayout(response.layouts[map.indexOf("reminders")]);
        this.remindersTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeEntry, MCT.TodoDescription_SelectedEntriesListNames.reminders, "userID"));
        this.remindersTable.setCyAttribute("TodoDescriptionEditorRemindersTable");

        //this.remindersTable.setRowClick(lang.hitch(this, this._onRowClick))

        this.associateGroupsTable = new StaticTable();
        this.associateGroupsTable.placeAt(this.associateGroupsTableContainer);

        this.associateGroupsTable.setLayout(response.layouts[map.indexOf("associateGroups")]);
        this.associateGroupsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeEntry, MCT.TodoDescription_SelectedEntriesListNames.associateGroups, "groupID"));
        this.associateGroupsTable.setCyAttribute("TodoDescriptionEditorAssociateGroupsTable");

        //this.associateGroupsTable.setRowClick(lang.hitch(this, this._onRowClick))

        this.todoTelecommunicationsTable = new StaticTable();
        this.todoTelecommunicationsTable.placeAt(this.todoTelecommunicationsTableContainer);

        this.todoTelecommunicationsTable.setLayout(response.layouts[map.indexOf("todoTelecommunications")]);
        this.todoTelecommunicationsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeEntry, MCT.TodoDescription_SelectedEntriesListNames.todoTelecommunications, "telecomID"));
        this.todoTelecommunicationsTable.setCyAttribute("TodoDescriptionEditorTelecommunicationsTable");

        //this.todoTelecommunicationsTable.setRowClick(lang.hitch(this, this._onRowClick))

        this.todoPackageTable = new StaticTable();
        this.todoPackageTable.placeAt(this.todoPackageTableContainer);

        this.todoPackageTable.setLayout(response.layouts[map.indexOf("todoPackages")]);
        this.todoPackageTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeEntry, MCT.TodoDescription_SelectedEntriesListNames.todoPackages, "packageID"));
        this.todoPackageTable.setCyAttribute("TodoDescriptionEditorPackageTable");

        //this.todoPackageTable.setRowClick(lang.hitch(this, this._onRowClick))

        this._updateTablesTimeoutHandler = setTimeout(() => {
            this._updateAllTables();
        }, 500);
    }

    private _onClick_OpenSED(identifierName, evt) {

        this.loadSelectEntityDialog(evt,
            identifierName,
            lang.hitch(this, this._onCallback_Dlg)
        );
    }

    private _onCallback_Dlg(mode: string,
        data,
        items: Array<SelectEntityDialogTypes.Item<MCT.TodoDescription_RemindersData | MCT.TodoDescription_AssociateGroupsData | MCT.TodoDescription_TodoTelecommunicationsData | MCT.TodoDescription_TodoPackageData>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;

        switch (mode) {
            case "selectReminderEvisUsers":

                for (let item of items) {
                    let entity: Partial<MCT.TodoDescription_RemindersData> = item.entry?.data;
                    if (!entity) {
                        entity = {
                            ID: item.entry.value, gDisp_1: item.entry.label
                        };
                    }
                    this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.reminders, entity as any, "userID", "gDisp_1");
                }
                break;
            case "selectAssociateGroups":

                for (let item of items) {
                    let entity: Partial<MCT.TodoDescription_AssociateGroupsData> = item.entry?.data;
                    if (!entity) {
                        entity = {
                            ID: item.entry.value, description: item.entry.label
                        };
                    }
                    this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.associateGroups, entity as any, "groupID", "description");
                }
                break;
            case "selectTodoTelecommunications":

                for (let item of items) {
                    let entity: Partial<MCT.TodoDescription_TodoTelecommunicationsData> = item.entry?.data;
                    if (!entity) {
                        entity = {
                            ID: item.entry.value, telecom_code: item.entry.label, description: item.entry.secondaryLabel
                        };
                    }
                    this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.todoTelecommunications, entity as any, "telecomID", "telecom_code");
                }
                break;
            case "selectTodoPackage":

                for (let item of items) {
                    let entity: Partial<MCT.TodoDescription_TodoPackageData> = item.entry?.data;
                    if (!entity) {
                        entity = {
                            ID: item.entry.value, description: item.entry.label
                        };
                    }
                    this.addNewEntry(MCT.TodoDescription_SelectedEntriesListNames.todoPackages, entity as any, "packageID", "description");
                }
                break;
        }
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._createSelectOptionsFromEnum();
        this._setUpTodoCategorySelect();

        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetTodoDescriptionListsTablesLayouts",
            null,
            lang.hitch(this, this._setUpTables),
            (err) => { this.showToast(err.Message) }
        )

        this.inputReminders.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectReminderEvisUsers"));
        this.inputAssociateGroups.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectAssociateGroups"));
        this.inputTodoTelecommunications.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectTodoTelecommunications"));
        this.inputTodoPackage.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectTodoPackage"));
        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";

        this.checkbox_Active.on("change", lang.hitch(this, lang.hitch(this, this._onChange_IsActiveCheckbox)));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private _onChange_IsActiveCheckbox(){
        if ((this.isNew ?? false) == true){
            return;
        }
        let isActive = this.checkbox_Active.getValue() ?? true;
        this.input_Description.setReadonly(!isActive);
        this.input_Note.setReadonly(!isActive);
        if (this.dayForerunIsReadOnly == false){
            this.input_DaysForerun1.setReadonly(!isActive);
            this.input_DaysForerun2.setReadonly(!isActive);
        }
        this.inputReminders.setReadonly(!isActive);
        this.remindersTable?.setReadonly(!isActive);
        this.inputAssociateGroups.setReadonly(!isActive);
        this.associateGroupsTable?.setReadonly(!isActive);
        this.inputTodoPackage.setReadonly(!isActive);
        this.todoPackageTable?.setReadonly(!isActive);
    }
}

export default mdsWidget(TodoDescriptionEditor);
